module.exports = __webpack_public_path__ + "img/xr_light.0a76a81b.jpg";